module.exports = {
    "listTitle": "mc9c3d73b2_listTitle",
    "listItem": "mc9c3d73b2_listItem",
    "block": "mc9c3d73b2_block",
    "groupBlock": "mc9c3d73b2_groupBlock"
};